// extracted by mini-css-extract-plugin
export default {"floor_name":"FloorName_floor_name__1TURf"};